import React from 'react';
import LoginActions from '../../actions/login-actions';
import LoginStore from '../../stores/login-store';
import PostHogService from '../../services/posthog';
import PostHogEvents from '../../constants/posthog-events';
import Analytics from '../../services/analytics';
import Loading from '../loading/loading';

class MarketingLogin extends React.Component {
    constructor() {
        super();
        this._onChange = this._onChange.bind(this);
        this.state = {
            error: false,
            error_message: '',
            loading: false
        };
    }

    componentDidMount() {
        LoginStore.addChangeListener(this._onChange);
    }

    componentWillUnmount() {
        LoginStore.removeChangeListener(this._onChange);
    }

    handleSubmit(e) {
        e.preventDefault();

        this.setState({ loading: true });

        let email = this.refs.email.value;
        let password = this.refs.password.value;

        if (email.length && password.length) {
            LoginActions.login(email, password);
            return;
        }

        this.setState({
            loading: false,
            error: true,
            error_message: 'Please complete all fields!'
        });
    }

    handleClick(e) {
        e.preventDefault();
        LoginActions.forgotPassword();
        PostHogService.capture(PostHogEvents.FORGOT_PASSWORD_REQUESTED);
    }

    _onChange(payload) {
        // a background refresh of an already signed-in user, not this form signing in
        if (payload && payload.refreshed) return;

        if (LoginStore.errors) {
            return this.setState({
                loading: false,
                error: true,
                error_message: LoginStore.errors
            });
        }

        if (LoginStore.isLoggedIn() && !this.reloading) {
            this.reloading = true;
            // the reload would drop an event still queued, so wait for it to be sent
            Analytics.event('login', { method: 'email' }, () => {
                window.history.replaceState(null, null, window.location.pathname);
                window.location.reload();
            });
        }
    }

    render() {
        return (
            <div className="marketing-auth-block" style={{ padding: '36px 32px' }}>
                {(this.state.loading) ? <Loading text="Please wait..." /> : null}

                <div style={{ textAlign: 'center', marginBottom: '32px' }}>
                    <h2 style={{ fontFamily: 'var(--font-serif)', fontSize: '28px', color: 'var(--heading)', fontWeight: 400, marginBottom: '8px' }}>Welcome Back</h2>
                    <p style={{ fontSize: '14px', color: 'var(--muted)' }}>Enter your email and password to sign in</p>
                </div>

                <form onSubmit={this.handleSubmit.bind(this)} style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>

                    {
                        (this.state.error) ? (
                            <div className="alert alert-danger" style={{ background: 'var(--red-50)', color: 'var(--red-400)', padding: '12px 16px', borderRadius: '8px', borderLeft: '3px solid var(--red-400)', fontSize: '13.5px' }}>
                                {this.state.error_message}
                            </div>
                        ) : null
                    }

                    <div className="input-group">
                        <label className="input-label" htmlFor="email">Email Address</label>
                        <input
                            className="input-field"
                            id="email"
                            type="email"
                            ref="email"
                            name="email"
                            placeholder="doctor@hospital.com"
                            required
                        />
                    </div>

                    <div className="input-group">
                        <label className="input-label" htmlFor="password">Password</label>
                        <input
                            className="input-field"
                            id="password"
                            type="password"
                            ref="password"
                            name="password"
                            placeholder="••••••••"
                            required
                        />
                    </div>

                    <div style={{ marginTop: '12px' }}>
                        <button type="submit" className="btn btn-primary-sm" style={{ width: '100%', padding: '14px', fontSize: '15px' }}>Sign In</button>
                    </div>

                    <div style={{ textAlign: 'center', marginTop: '16px', fontSize: '13.5px', color: 'var(--muted)' }}>
                        Forgot your password? <button type="button" className="btn-ghost-nav" style={{ color: 'var(--blue-600)', padding: 0, textDecoration: 'underline' }} onClick={this.handleClick.bind(this)}>Click here</button>
                    </div>
                </form>
            </div>
        );
    }
}

export default MarketingLogin;
